import React from 'react';
import './legal.css';

export default function Terms() {
  return (
    <div className="legal-page">
      <h1>Terms of Use</h1>
      <div className="meta">Updated: October 4, 2025</div>
      <p><strong>Developer:</strong> IliaStasik (operated by ILIA STASIK SERGEY, IE, 22A Nairi Zaryan Street, 0051, Yerevan, Armenia)</p>

      <p>By downloading, installing, or using any IliaStasik game or mobile application (“Games”), you agree to these Terms of Use (“Agreement”) and our Privacy Policy. If you do not agree, you may not use the Games.</p>

      <h2>1. Eligibility & Age</h2>
      <ul>
        <li>You must be at least 16 years old to use our Games.</li>
        <li>Users under 18 may use the Games only with parental or legal guardian consent.</li>
        <li>IliaStasik may request verification of age and identity at any time.</li>
      </ul>

      <h2>2. License & Restrictions</h2>
      <h3>2.1 License</h3>
      <p>IliaStasik grants you a personal, non-transferable, non-exclusive license to download and play the Games on devices you own or control.</p>

      <h3>2.2 Restrictions</h3>
      <p>You may not:</p>
      <ul>
        <li>Copy, modify, distribute, or commercially exploit the Games.</li>
        <li>Reverse engineer, decompile, or attempt to extract source code.</li>
        <li>Use the Games to develop competitive products.</li>
        <li>Remove copyright or proprietary notices.</li>
      </ul>

      <h3>2.3 Ownership</h3>
      <p>All Games and associated intellectual property are owned by IliaStasik or its licensors. This Agreement does not transfer ownership to you.</p>

      <h2>3. Virtual Items & In-App Purchases</h2>
      <p>Games may offer virtual items, currency, or subscriptions (“Virtual Items”). Virtual Items are licensed, not sold, and are non-transferable, non-sublicensable, revocable, and for personal use only. Prices, availability, and features of Virtual Items may change without notice. No refunds: Purchases of Virtual Items or subscriptions are final, except where required by law. Deleting your account or requesting data erasure will permanently remove Virtual Items with no refund. Virtual Items have no real-world cash value.</p>

      <h2>4. Ads & Third-Party Services</h2>
      <p>Games may include ads (banner, interstitial, rewarded video) provided by third-party networks. Third-party analytics and ad services may collect device and usage data as described in our Privacy Policy. IliaStasik is not responsible for third-party content or ads.</p>

      <h2>5. User-Generated Content (UGC)</h2>
      <p>“User Content” is any content you submit, post, or upload in the Games. You retain ownership but grant IliaStasik a worldwide, royalty-free, sublicensable license to display, distribute, and modify User Content within the Games.</p>
      <p>You must not post content that:</p>
      <ul>
        <li>Violates intellectual property rights or laws</li>
        <li>Is abusive, obscene, hateful, violent, or harmful to minors</li>
        <li>Constitutes spam or malware</li>
      </ul>
      <p>IliaStasik may remove User Content at any time without notice.</p>

      <h2>6. Account Termination</h2>
      <p>IliaStasik may suspend or terminate your account for violating this Agreement or the Acceptable Use Policy. Upon termination, all User Content, progress, and Virtual Items will be deleted. Sections covering ownership, liability, and indemnity will survive termination.</p>

      <h2>7. Fees & Billing</h2>
      <p>In-app purchases and subscriptions are handled by the App Store or Google Play. All payments are subject to the platform’s terms. IliaStasik is not responsible for billing errors or platform payment processing. Subscriptions automatically renew unless canceled 24 hours before the end of the current period.</p>

      <h2>8. Disclaimer & Limitation of Liability</h2>
      <p>Games are provided “as-is” and “as available.” IliaStasik disclaims all warranties, including merchantability and fitness for a particular purpose. You use the Games at your own risk; IliaStasik is not liable for damages, including loss of data, profits, or Virtual Items. Liability is limited to the maximum extent permitted by law.</p>

      <h2>9. Indemnity</h2>
      <p>You agree to defend, indemnify, and hold harmless IliaStasik from claims, damages, or losses arising from your use of the Games, User Content, or violation of this Agreement.</p>

      <h2>10. Third Parties</h2>
      <ul>
        <li><strong>App Stores:</strong> License is with IliaStasik, not the store. Compliance with the store’s terms is required.</li>
        <li><strong>Third-Party Services:</strong> Games may integrate external services. IliaStasik is not responsible for these services.</li>
        <li><strong>Other Users:</strong> Interactions with other users are your responsibility. IliaStasik is not liable for disputes or damages from other users.</li>
      </ul>

      <h2>11. Governing Law & Miscellaneous</h2>
      <p>This Agreement is governed by the laws of Armenia. Notices should be sent to <a href="mailto:isstasik@gmail.com">isstasik@gmail.com</a>. If any part of this Agreement is invalid, the remaining provisions remain in effect. This Agreement, along with the Privacy Policy, constitutes the entire agreement.</p>
    </div>
  );
}
